/* eslint-disable linebreak-style */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/inventory';

@Injectable({
  providedIn: 'root'
})
export default class InventoryService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
